// extracted by mini-css-extract-plugin
export default {"news":"news_news__+qgZA","imgwrap":"news_imgwrap__8Rslc","content_wrap":"news_content_wrap__LawAY","title":"news_title__gUX1g","content":"news_content__2e6MO"};